import moment from 'moment'
import { useMemo } from 'react'
import useGraphQLFetch from '../../../Utils/Hooks/useGraphQLFetch'
import { readNoShowMissionLog } from '../../City/Page/Ambasador/gql'
import { authorization } from '../../../Module/Auth/Auth'

export const useNoShowLog = ({ mission = {} }) => {
  const { data: noShowMissionLogsData, isLoaded } = useGraphQLFetch({
    fetchFn: readNoShowMissionLog,
    defaultFetchArgs: { missionId: mission.id },
    mapResponse: ({ readNoShowMissionLog }) => readNoShowMissionLog,
  })
  const isCityManagerAssistant = authorization.isCityManagerAssistant()
  const showHistory = !authorization.isClient() && !isCityManagerAssistant

  const latestNoShowStatus = useMemo(
    () =>
      noShowMissionLogsData
        ? noShowMissionLogsData.reduce((latest, current) => {
            return moment(current.date).isAfter(moment(latest.date))
              ? current
              : latest
          }, noShowMissionLogsData[noShowMissionLogsData.length - 1])
        : null,
    [noShowMissionLogsData],
  )

  const logs = useMemo(
    () =>
      noShowMissionLogsData
        ? noShowMissionLogsData
            .map(log => ({
              ...log,
              date: moment(log.date).tz(mission.city.timezone),
            }))
            .sort((a, b) => moment(b.date).diff(moment(a.date)))
        : null,
    [noShowMissionLogsData],
  )

  const showBadge = useMemo(() => {
    if (!isLoaded || !mission.isNotShown || !showHistory) return false
    return mission.user && latestNoShowStatus && latestNoShowStatus.user
      ? `${mission.user.id}` === `${latestNoShowStatus.user.id}`
      : false
  }, [isLoaded, latestNoShowStatus, mission])

  return { showBadge, latestNoShowStatus, logs, showHistory }
}
